import { jsx as d } from "react/jsx-runtime";
import { isValidElement as b, Children as a } from "react";
function C(p) {
  return p && p.__esModule && Object.prototype.hasOwnProperty.call(p, "default") ? p.default : p;
}
var s = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var z;
function w() {
  return z || (z = 1, function(p) {
    (function() {
      var o = {}.hasOwnProperty;
      function u() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var _ = arguments[i];
          _ && (r = e(r, l.call(this, _)));
        }
        return r;
      }
      function l(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var _ in r)
          o.call(r, _) && r[_] && (i = e(i, this && this[_] || _));
        return i;
      }
      function e(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      p.exports ? (u.default = u, p.exports = u) : window.classNames = u;
    })();
  }(s)), s.exports;
}
var I = w();
const f = /* @__PURE__ */ C(I), O = {
  "purpur-grid-item": "_purpur-grid-item_zx9tz_1",
  "purpur-grid-item--no-col-gap": "_purpur-grid-item--no-col-gap_zx9tz_6",
  "purpur-grid-item-colspan-sm-4": "_purpur-grid-item-colspan-sm-4_zx9tz_24",
  "purpur-grid-item-colspan-sm-3": "_purpur-grid-item-colspan-sm-3_zx9tz_27",
  "purpur-grid-item-colspan-sm-2": "_purpur-grid-item-colspan-sm-2_zx9tz_30",
  "purpur-grid-item-colspan-sm-1": "_purpur-grid-item-colspan-sm-1_zx9tz_33",
  "purpur-grid-item-colspan-md-8": "_purpur-grid-item-colspan-md-8_zx9tz_37",
  "purpur-grid-item-colspan-md-7": "_purpur-grid-item-colspan-md-7_zx9tz_42",
  "purpur-grid-item-colspan-md-6": "_purpur-grid-item-colspan-md-6_zx9tz_47",
  "purpur-grid-item-colspan-md-5": "_purpur-grid-item-colspan-md-5_zx9tz_52",
  "purpur-grid-item-colspan-md-4": "_purpur-grid-item-colspan-md-4_zx9tz_57",
  "purpur-grid-item-colspan-md-3": "_purpur-grid-item-colspan-md-3_zx9tz_62",
  "purpur-grid-item-colspan-md-2": "_purpur-grid-item-colspan-md-2_zx9tz_67",
  "purpur-grid-item-colspan-md-1": "_purpur-grid-item-colspan-md-1_zx9tz_72",
  "purpur-grid-item-colspan-lg-12": "_purpur-grid-item-colspan-lg-12_zx9tz_77",
  "purpur-grid-item-colspan-lg-11": "_purpur-grid-item-colspan-lg-11_zx9tz_82",
  "purpur-grid-item-colspan-lg-10": "_purpur-grid-item-colspan-lg-10_zx9tz_87",
  "purpur-grid-item-colspan-lg-9": "_purpur-grid-item-colspan-lg-9_zx9tz_92",
  "purpur-grid-item-colspan-lg-8": "_purpur-grid-item-colspan-lg-8_zx9tz_97",
  "purpur-grid-item-colspan-lg-7": "_purpur-grid-item-colspan-lg-7_zx9tz_102",
  "purpur-grid-item-colspan-lg-6": "_purpur-grid-item-colspan-lg-6_zx9tz_107",
  "purpur-grid-item-colspan-lg-5": "_purpur-grid-item-colspan-lg-5_zx9tz_112",
  "purpur-grid-item-colspan-lg-4": "_purpur-grid-item-colspan-lg-4_zx9tz_117",
  "purpur-grid-item-colspan-lg-3": "_purpur-grid-item-colspan-lg-3_zx9tz_122",
  "purpur-grid-item-colspan-lg-2": "_purpur-grid-item-colspan-lg-2_zx9tz_127",
  "purpur-grid-item-colspan-lg-1": "_purpur-grid-item-colspan-lg-1_zx9tz_77"
}, S = f.bind(O), g = "purpur-grid-item", c = ({
  children: p,
  className: o,
  colSpanSm: u = 4,
  colSpanMd: l = 8,
  colSpanLg: e = 12,
  noColGap: r = !1,
  ...i
}) => {
  const _ = S([
    o,
    g,
    {
      [`${g}--no-col-gap`]: r,
      [`${g}-colspan-sm-${u}`]: u,
      [`${g}-colspan-md-${l}`]: l,
      [`${g}-colspan-lg-${e}`]: e
    }
  ]);
  return /* @__PURE__ */ d("div", { className: _, ...i, children: p });
}, A = (p) => !!p && b(p) && (!!p.props.colSpanSm || !!p.props.colSpanMd || !!p.props.colSpanLg);
c.displayName = "Grid.Item";
const E = {
  "purpur-grid": "_purpur-grid_8kjv6_1",
  "purpur-grid__inner": "_purpur-grid__inner_8kjv6_27",
  "purpur-grid__inner--no-gap": "_purpur-grid__inner--no-gap_8kjv6_32",
  "purpur-grid__inner--no-row-gap": "_purpur-grid__inner--no-row-gap_8kjv6_32",
  "purpur-grid__inner--grid": "_purpur-grid__inner--grid_8kjv6_50",
  "purpur-grid__inner--no-col-gap": "_purpur-grid__inner--no-col-gap_8kjv6_54",
  "purpur-grid__inner-col-sm-4": "_purpur-grid__inner-col-sm-4_8kjv6_57",
  "purpur-grid__inner-col-sm-3": "_purpur-grid__inner-col-sm-3_8kjv6_60",
  "purpur-grid__inner-col-sm-2": "_purpur-grid__inner-col-sm-2_8kjv6_63",
  "purpur-grid__inner-col-md-8": "_purpur-grid__inner-col-md-8_8kjv6_67",
  "purpur-grid__inner-col-md-7": "_purpur-grid__inner-col-md-7_8kjv6_72",
  "purpur-grid__inner-col-md-6": "_purpur-grid__inner-col-md-6_8kjv6_77",
  "purpur-grid__inner-col-md-5": "_purpur-grid__inner-col-md-5_8kjv6_82",
  "purpur-grid__inner-col-md-4": "_purpur-grid__inner-col-md-4_8kjv6_87",
  "purpur-grid__inner-col-md-3": "_purpur-grid__inner-col-md-3_8kjv6_92",
  "purpur-grid__inner-col-md-2": "_purpur-grid__inner-col-md-2_8kjv6_97",
  "purpur-grid__inner-col-lg-12": "_purpur-grid__inner-col-lg-12_8kjv6_102",
  "purpur-grid__inner-col-lg-11": "_purpur-grid__inner-col-lg-11_8kjv6_107",
  "purpur-grid__inner-col-lg-10": "_purpur-grid__inner-col-lg-10_8kjv6_112",
  "purpur-grid__inner-col-lg-9": "_purpur-grid__inner-col-lg-9_8kjv6_117",
  "purpur-grid__inner-col-lg-8": "_purpur-grid__inner-col-lg-8_8kjv6_122",
  "purpur-grid__inner-col-lg-7": "_purpur-grid__inner-col-lg-7_8kjv6_127",
  "purpur-grid__inner-col-lg-6": "_purpur-grid__inner-col-lg-6_8kjv6_132",
  "purpur-grid__inner-col-lg-5": "_purpur-grid__inner-col-lg-5_8kjv6_137",
  "purpur-grid__inner-col-lg-4": "_purpur-grid__inner-col-lg-4_8kjv6_142",
  "purpur-grid__inner-col-lg-3": "_purpur-grid__inner-col-lg-3_8kjv6_147",
  "purpur-grid__inner-col-lg-2": "_purpur-grid__inner-col-lg-2_8kjv6_152",
  "purpur-grid__inner--flex": "_purpur-grid__inner--flex_8kjv6_156"
}, v = f.bind(E), q = "purpur-grid", n = "purpur-grid__inner", x = ({
  children: p,
  className: o,
  containerClassName: u,
  colsSm: l = 1,
  colsMd: e = 1,
  colsLg: r = 1,
  noGap: i = !1,
  noColGap: _ = !1,
  noRowGap: j = !1,
  ...k
}) => {
  const m = a.toArray(p).filter(A), t = m.length, $ = v([u, q]), h = v([
    o,
    n,
    {
      [`${n}--grid`]: !t,
      [`${n}--flex`]: t,
      [`${n}--no-gap`]: i,
      [`${n}--no-col-gap`]: _,
      [`${n}--no-row-gap`]: j,
      [`${n}-col-sm-${l}`]: l > 1 && !t,
      [`${n}-col-md-${e}`]: e > 1 && !t,
      [`${n}-col-lg-${r}`]: r > 1 && !t
    }
  ]);
  return /* @__PURE__ */ d("div", { className: $, ...k, children: /* @__PURE__ */ d("div", { className: h, children: t ? a.map(m, ({ props: { children: y, ...N } }) => /* @__PURE__ */ d(c, { ...N, noColGap: i || _, children: y })) : p }) });
};
x.displayName = "Grid";
x.Item = c;
export {
  x as Grid
};
//# sourceMappingURL=grid.es.js.map
